<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="content-section">
    <h2>Qu'est-ce que la RC Pro Générale ?</h2>
    <p class="intro-text">
      L'assurance <strong>Responsabilité Civile Professionnelle (RC Pro) Générale</strong> est une protection 
      indispensable qui couvre les dommages causés à des tiers dans le cadre de votre activité professionnelle. 
      Elle protège votre entreprise contre les conséquences financières des erreurs, négligences, ou fautes 
      professionnelles qui peuvent survenir dans l'exercice quotidien de votre métier.
    </p>

    <div class="obligation-info">
      <div class="obligation-header">
        <i class="fas fa-exclamation-triangle"></i>
        <h3>Obligation légale pour certaines professions</h3>
      </div>
      <p>
        La RC Pro est <strong>obligatoire</strong> pour de nombreuses professions réglementées : 
        professionnels de santé, du bâtiment, du droit, experts-comptables, agents immobiliers, 
        architectes, etc. Pour les autres activités, elle reste vivement recommandée car elle 
        protège votre patrimoine professionnel et personnel.
      </p>
    </div>
  </div>

  <div class="content-section">
    <h2>Professions Concernées par la RC Pro</h2>
    
    <div class="professions-grid">
      <div class="profession-category">
        <div class="category-header obligatoire">
          <i class="fas fa-gavel"></i>
          <h3>RC Pro Obligatoire</h3>
        </div>
        <ul class="profession-list">
          <li><i class="fas fa-check"></i> Professions de santé (médecins, infirmiers, pharmaciens)</li>
          <li><i class="fas fa-check"></i> Professions juridiques (avocats, notaires, huissiers)</li>
          <li><i class="fas fa-check"></i> Experts-comptables et commissaires aux comptes</li>
          <li><i class="fas fa-check"></i> Agents immobiliers et syndics</li>
          <li><i class="fas fa-check"></i> Architectes et géomètres</li>
          <li><i class="fas fa-check"></i> Professions du bâtiment (avec garantie décennale)</li>
          <li><i class="fas fa-check"></i> Agents de voyages et tour-opérateurs</li>
          <li><i class="fas fa-check"></i> Courtiers en assurance</li>
          <li><i class="fas fa-check"></i> Experts automobiles</li>
          <li><i class="fas fa-check"></i> Agences de mannequins</li>
        </ul>
      </div>

      <div class="profession-category">
        <div class="category-header recommandee">
          <i class="fas fa-shield-alt"></i>
          <h3>RC Pro Fortement Recommandée</h3>
        </div>
        <ul class="profession-list">
          <li><i class="fas fa-arrow-right"></i> Consultants et freelances</li>
          <li><i class="fas fa-arrow-right"></i> Informaticiens et développeurs</li>
          <li><i class="fas fa-arrow-right"></i> Graphistes et créatifs</li>
          <li><i class="fas fa-arrow-right"></i> Formateurs et coaches</li>
          <li><i class="fas fa-arrow-right"></i> Commerçants et artisans</li>
          <li><i class="fas fa-arrow-right"></i> Restaurateurs et traiteurs</li>
          <li><i class="fas fa-arrow-right"></i> Coiffeurs et esthéticiens</li>
          <li><i class="fas fa-arrow-right"></i> Agences de communication</li>
          <li><i class="fas fa-arrow-right"></i> Photographes et vidéastes</li>
          <li><i class="fas fa-arrow-right"></i> Auto-entrepreneurs toutes activités</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Les Garanties de la RC Pro Générale</h2>

    <div class="garanties-section">
      <div class="garantie-block garantie-base">
        <div class="garantie-header">
          <i class="fas fa-certificate"></i>
          <h3>Garanties de Base (Incluses)</h3>
        </div>
        <div class="garantie-content">
          <div class="garantie-item">
            <h4><i class="fas fa-user-injured"></i> Dommages Corporels</h4>
            <p>
              Indemnisation des blessures ou atteintes à la santé causées à des tiers (clients, 
              fournisseurs, visiteurs) dans le cadre de votre activité. Couvre les frais médicaux, 
              l'incapacité temporaire ou permanente, et le préjudice moral.
            </p>
            <div class="plafond">Plafond habituel : 1 000 000 € à 5 000 000 €</div>
          </div>

          <div class="garantie-item">
            <h4><i class="fas fa-tools"></i> Dommages Matériels</h4>
            <p>
              Réparation ou remplacement des biens endommagés appartenant à des tiers suite à une 
              erreur professionnelle, une négligence, ou un accident causé par votre activité ou vos 
              collaborateurs.
            </p>
            <div class="plafond">Plafond habituel : 500 000 € à 2 000 000 €</div>
          </div>

          <div class="garantie-item">
            <h4><i class="fas fa-euro-sign"></i> Dommages Immatériels Consécutifs</h4>
            <p>
              Prise en charge des pertes financières subies par un tiers à la suite d'un dommage 
              corporel ou matériel : perte de revenus, manque à gagner, frais supplémentaires 
              engagés pour pallier le préjudice.
            </p>
            <div class="plafond">Plafond habituel : 500 000 € à 2 000 000 €</div>
          </div>

          <div class="garantie-item">
            <h4><i class="fas fa-file-contract"></i> Dommages Immatériels Non-Consécutifs</h4>
            <p>
              <strong>Option souvent incluse ou en extension :</strong> couvre les préjudices financiers 
              purs sans dommage corporel ou matériel préalable. Exemples : erreur de conseil, retard de 
              livraison, non-respect des délais, faute professionnelle pure.
            </p>
            <div class="plafond">Plafond habituel : 150 000 € à 1 000 000 €</div>
          </div>

          <div class="garantie-item">
            <h4><i class="fas fa-balance-scale"></i> Défense et Recours</h4>
            <p>
              Prise en charge des frais de défense juridique (avocat, expertise, procédure) en cas de 
              mise en cause de votre responsabilité, ainsi que des frais de recours contre un tiers 
              responsable.
            </p>
            <div class="plafond">Plafond habituel : 30 000 € à 100 000 €</div>
          </div>

          <div class="garantie-item">
            <h4><i class="fas fa-hands-helping"></i> Faute Inexcusable et Faute Intentionnelle Préposés</h4>
            <p>
              Extension importante : couvre les conséquences d'une faute inexcusable de l'employeur 
              ou d'une faute intentionnelle commise par un salarié (mais pas celle du dirigeant).
            </p>
            <div class="plafond">Selon contrat</div>
          </div>
        </div>
      </div>

      <div class="garantie-block garantie-optionnelle">
        <div class="garantie-header">
          <i class="fas fa-plus-circle"></i>
          <h3>Extensions de Garantie (En Option)</h3>
        </div>
        <div class="garantie-content">
          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-briefcase"></i>
              <h4>RC Après Livraison (Produits)</h4>
              <span class="cout">+ 80 € à 400 €/an</span>
            </div>
            <p>
              Couvre les dommages causés par un produit après sa livraison ou vente, incluant les 
              défauts de fabrication, vice caché, ou non-conformité.
            </p>
          </div>

          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-laptop-code"></i>
              <h4>Atteinte aux Données (Cyber-responsabilité)</h4>
              <span class="cout">+ 150 € à 800 €/an</span>
            </div>
            <p>
              Protection en cas de violation de données personnelles, perte ou divulgation d'informations 
              confidentielles clients, non-conformité RGPD.
            </p>
          </div>

          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-hand-holding-usd"></i>
              <h4>Responsabilité Civile Mandataire Social</h4>
              <span class="cout">+ 200 € à 1 500 €/an</span>
            </div>
            <p>
              Couvre les dirigeants (gérant, PDG, administrateurs) contre les fautes de gestion, 
              manquements aux obligations légales, ou décisions préjudiciables.
            </p>
          </div>

          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-globe-americas"></i>
              <h4>Extension Géographique Monde Entier</h4>
              <span class="cout">+ 100 € à 600 €/an</span>
            </div>
            <p>
              Étend la couverture à l'international pour les activités hors de France (généralement 
              hors USA/Canada qui nécessitent une garantie spécifique).
            </p>
          </div>

          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-file-signature"></i>
              <h4>Garantie Décennale (BTP)</h4>
              <span class="cout">+ 500 € à 10 000 €/an</span>
            </div>
            <p>
              Obligatoire pour le secteur du bâtiment : couvre les dommages de nature décennale 
              affectant la solidité de l'ouvrage pendant 10 ans après réception.
            </p>
          </div>

          <div class="extension-item">
            <div class="extension-title">
              <i class="fas fa-umbrella"></i>
              <h4>Augmentation des Plafonds</h4>
              <span class="cout">+ 50 € à 500 €/an</span>
            </div>
            <p>
              Possibilité d'augmenter les plafonds de garantie au-delà des montants standards pour 
              une protection renforcée (utile pour les gros contrats).
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Tarifs de la RC Pro Générale</h2>
    <p class="section-intro">
      Le coût de l'assurance RC Pro varie considérablement selon votre secteur d'activité, votre chiffre 
      d'affaires, le nombre de salariés, et les risques inhérents à votre profession.
    </p>

    <div class="pricing-by-sector">
      <div class="sector-pricing risque-faible">
        <div class="sector-header">
          <i class="fas fa-check-circle"></i>
          <h3>Activités à Risque Faible</h3>
        </div>
        <div class="sector-content">
          <div class="price-range">
            <div class="price-main">150 € - 800 €</div>
            <div class="price-detail">par an</div>
          </div>
          <ul class="sector-examples">
            <li><i class="fas fa-laptop"></i> Consultants et conseil (hors conseil juridique/financier)</li>
            <li><i class="fas fa-graduation-cap"></i> Formateurs et coaches</li>
            <li><i class="fas fa-pencil-alt"></i> Graphistes et créatifs</li>
            <li><i class="fas fa-camera"></i> Photographes</li>
            <li><i class="fas fa-clipboard-check"></i> Services administratifs</li>
            <li><i class="fas fa-comments"></i> Traducteurs et rédacteurs</li>
          </ul>
          <div class="sector-note">
            <strong>Caractéristiques :</strong> Activités intellectuelles sans manipulation de biens, 
            peu de contact physique avec les clients, risques principalement immatériels.
          </div>
        </div>
      </div>

      <div class="sector-pricing risque-moyen">
        <div class="sector-header">
          <i class="fas fa-exclamation-circle"></i>
          <h3>Activités à Risque Moyen</h3>
        </div>
        <div class="sector-content">
          <div class="price-range">
            <div class="price-main">500 € - 2 500 €</div>
            <div class="price-detail">par an</div>
          </div>
          <ul class="sector-examples">
            <li><i class="fas fa-store"></i> Commerçants (boutiques, magasins)</li>
            <li><i class="fas fa-cut"></i> Coiffeurs et esthéticiens</li>
            <li><i class="fas fa-utensils"></i> Restaurateurs et traiteurs</li>
            <li><i class="fas fa-car"></i> Garages et carrossiers</li>
            <li><i class="fas fa-toolbox"></i> Artisans (plomberie, électricité, menuiserie)</li>
            <li><i class="fas fa-network-wired"></i> Agences web et marketing digital</li>
            <li><i class="fas fa-desktop"></i> Informaticiens et développeurs</li>
          </ul>
          <div class="sector-note">
            <strong>Caractéristiques :</strong> Contact avec la clientèle, manipulation de biens ou 
            prestations techniques, risques matériels et corporels modérés.
          </div>
        </div>
      </div>

      <div class="sector-pricing risque-eleve">
        <div class="sector-header">
          <i class="fas fa-times-circle"></i>
          <h3>Activités à Risque Élevé</h3>
        </div>
        <div class="sector-content">
          <div class="price-range">
            <div class="price-main">1 000 € - 10 000 €+</div>
            <div class="price-detail">par an</div>
          </div>
          <ul class="sector-examples">
            <li><i class="fas fa-hard-hat"></i> Professions du BTP (avec décennale)</li>
            <li><i class="fas fa-user-md"></i> Professionnels de santé</li>
            <li><i class="fas fa-balance-scale"></i> Professions juridiques</li>
            <li><i class="fas fa-calculator"></i> Experts-comptables</li>
            <li><i class="fas fa-drafting-compass"></i> Architectes et bureaux d'études</li>
            <li><i class="fas fa-shield-virus"></i> Laboratoires et industries chimiques</li>
            <li><i class="fas fa-rocket"></i> Agences événementielles</li>
            <li><i class="fas fa-industry"></i> Entreprises industrielles</li>
          </ul>
          <div class="sector-note">
            <strong>Caractéristiques :</strong> Activités réglementées, risques corporels ou financiers 
            importants, responsabilité engagée sur de longues périodes, montant des préjudices potentiels élevé.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Exemples de Tarifs selon la Profession</h2>

    <div class="pricing-examples">
      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-laptop-code"></i>
          <h3>Consultant Freelance</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Conseil en stratégie digitale</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">60 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">0 (auto-entrepreneur)</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Pro base + Dommages immatériels</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">500 000 € par sinistre</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">280 €</span>
          </div>
        </div>
      </div>

      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-store"></i>
          <h3>Commerce de Détail</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Boutique de vêtements</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">250 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">3</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Exploitation + RC Après Livraison</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">1 000 000 € par sinistre</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">650 €</span>
          </div>
        </div>
      </div>

      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-utensils"></i>
          <h3>Restaurant</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Restaurant traditionnel 60 couverts</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">400 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">8</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Exploitation + Intoxication alimentaire</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">2 000 000 € par sinistre</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">1 200 €</span>
          </div>
        </div>
      </div>

      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-tools"></i>
          <h3>Artisan Plombier</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Plomberie chauffage installation</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">150 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">2</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Pro + Décennale + Dommages aux biens confiés</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">1 500 000 € par sinistre</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">2 800 €</span>
          </div>
        </div>
      </div>

      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-desktop"></i>
          <h3>Agence Web</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Développement web et applications</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">500 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">12</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Pro + Cyber-responsabilité + Atteinte aux données</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">2 000 000 € RC + 500 000 € Cyber</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">1 800 €</span>
          </div>
        </div>
      </div>

      <div class="example-card">
        <div class="example-header">
          <i class="fas fa-calculator"></i>
          <h3>Expert-Comptable</h3>
        </div>
        <div class="example-details">
          <div class="detail-row">
            <span class="label">Activité :</span>
            <span class="value">Cabinet d'expertise comptable</span>
          </div>
          <div class="detail-row">
            <span class="label">Chiffre d'affaires :</span>
            <span class="value">800 000 €/an</span>
          </div>
          <div class="detail-row">
            <span class="label">Salariés :</span>
            <span class="value">15</span>
          </div>
          <div class="detail-row">
            <span class="label">Garanties :</span>
            <span class="value">RC Pro obligatoire + Protection juridique</span>
          </div>
          <div class="detail-row">
            <span class="label">Plafonds :</span>
            <span class="value">5 000 000 € par sinistre</span>
          </div>
          <div class="example-price">
            <span class="price-label">Prime annuelle :</span>
            <span class="price-value">4 500 €</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Critères d'Évaluation de la Prime</h2>
    <p class="section-intro">
      Les assureurs analysent plusieurs critères pour déterminer le montant de votre cotisation RC Pro.
    </p>

    <div class="criteria-grid">
      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-briefcase"></i>
        </div>
        <h3>Secteur d'Activité</h3>
        <p>
          Le risque varie fortement selon la nature de votre profession. Les activités réglementées 
          ou à fort enjeu (santé, BTP, conseil juridique) sont plus coûteuses à assurer.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">+/- 50% à 300%</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-chart-line"></i>
        </div>
        <h3>Chiffre d'Affaires</h3>
        <p>
          Plus votre CA est élevé, plus le risque de sinistre est important et plus les montants en 
          jeu sont conséquents. La cotisation est souvent calculée en pourcentage du CA.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">0,1% à 2% du CA</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-users"></i>
        </div>
        <h3>Nombre de Salariés</h3>
        <p>
          Chaque collaborateur augmente le risque d'erreur ou de faute professionnelle. Les assureurs 
          majorent la prime en fonction de l'effectif.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">+50 € à 300 €/salarié</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-shield-alt"></i>
        </div>
        <h3>Plafonds de Garantie</h3>
        <p>
          Des plafonds plus élevés offrent une meilleure protection mais augmentent la prime. Adaptez 
          les montants à vos besoins réels et à la taille de vos contrats.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">+10% à 50%</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-history"></i>
        </div>
        <h3>Antécédents et Sinistralité</h3>
        <p>
          Un historique de sinistres importants ou fréquents entraîne une majoration de la prime. À 
          l'inverse, l'absence de sinistre peut vous valoir des réductions.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">-20% à +100%</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <h3>Expérience et Qualifications</h3>
        <p>
          Une solide expérience professionnelle, des diplômes reconnus, et des certifications de 
          qualité (ISO, labels) peuvent réduire la prime.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">-5% à -15%</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-file-alt"></i>
        </div>
        <h3>Nature des Prestations</h3>
        <p>
          La complexité et la durée d'engagement de vos prestations influencent le risque. Un projet 
          court est moins risqué qu'un contrat sur plusieurs années.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">+10% à 50%</span>
        </div>
      </div>

      <div class="criterion-card">
        <div class="criterion-icon">
          <i class="fas fa-euro-sign"></i>
        </div>
        <h3>Franchise</h3>
        <p>
          Une franchise plus élevée (montant restant à votre charge en cas de sinistre) permet de 
          réduire le coût de la prime annuelle.
        </p>
        <div class="impact">
          <span class="impact-label">Impact :</span>
          <span class="impact-value">-5% à -20%</span>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Cas Pratiques et Sinistres Couverts</h2>

    <div class="sinistres-exemples">
      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-laptop-code"></i>
          <h3>Consultant en Marketing Digital</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Vous avez conseillé à un client une stratégie SEO qui s'est avérée inefficace. Le client 
            vous reproche une perte de chiffre d'affaires de 50 000 € et engage une action en justice.
          </p>
          <h4>Prise en charge RC Pro :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Frais d'avocat et de défense : 15 000 €</li>
            <li><i class="fas fa-check"></i> Indemnisation du préjudice financier (après expertise) : 25 000 €</li>
            <li><i class="fas fa-check"></i> Frais de médiation et d'expertise : 5 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 45 000 €
          </div>
        </div>
      </div>

      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-utensils"></i>
          <h3>Traiteur</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Lors d'un événement professionnel, plusieurs invités ont souffert d'une intoxication 
            alimentaire. 12 personnes hospitalisées, l'événement annulé, et des dommages d'image pour 
            l'entreprise cliente.
          </p>
          <h4>Prise en charge RC Pro :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Frais médicaux et hospitalisation : 30 000 €</li>
            <li><i class="fas fa-check"></i> Indemnisation préjudice moral (12 victimes) : 20 000 €</li>
            <li><i class="fas fa-check"></i> Remboursement prestation client : 15 000 €</li>
            <li><i class="fas fa-check"></i> Préjudice d'image et perte d'exploitation client : 40 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 105 000 €
          </div>
        </div>
      </div>

      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-tools"></i>
          <h3>Plombier</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Suite à une erreur lors de l'installation d'un système de chauffage, une fuite d'eau 
            importante a causé des dégâts dans l'appartement du client et celui du dessous.
          </p>
          <h4>Prise en charge RC Pro :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Réparation des dégâts des eaux (2 appartements) : 35 000 €</li>
            <li><i class="fas fa-check"></i> Remplacement du mobilier endommagé : 12 000 €</li>
            <li><i class="fas fa-check"></i> Frais de relogement temporaire : 4 000 €</li>
            <li><i class="fas fa-check"></i> Réinstallation du système de chauffage : 8 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 59 000 €
          </div>
        </div>
      </div>

      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-desktop"></i>
          <h3>Développeur Web</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Une faille de sécurité dans le site e-commerce que vous avez développé a permis une 
            violation de données. 5 000 clients affectés, obligation de notification RGPD.
          </p>
          <h4>Prise en charge RC Pro (avec extension cyber) :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Frais d'expertise technique et correction : 20 000 €</li>
            <li><i class="fas fa-check"></i> Notification des clients et communication de crise : 15 000 €</li>
            <li><i class="fas fa-check"></i> Indemnisation perte d'exploitation client : 50 000 €</li>
            <li><i class="fas fa-check"></i> Amende CNIL (partielle) : 30 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 115 000 €
          </div>
        </div>
      </div>

      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-cut"></i>
          <h3>Coiffeur</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Une cliente a subi une réaction allergique sévère suite à l'application d'une coloration. 
            Brûlures du cuir chevelu, perte de cheveux temporaire, et préjudice esthétique.
          </p>
          <h4>Prise en charge RC Pro :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Frais médicaux et traitement dermatologique : 8 000 €</li>
            <li><i class="fas fa-check"></i> Indemnisation préjudice esthétique : 15 000 €</li>
            <li><i class="fas fa-check"></i> Préjudice moral : 5 000 €</li>
            <li><i class="fas fa-check"></i> Frais de prothèse capillaire temporaire : 2 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 30 000 €
          </div>
        </div>
      </div>

      <div class="sinistre-card">
        <div class="sinistre-header">
          <i class="fas fa-store"></i>
          <h3>Commerce de Détail</h3>
        </div>
        <div class="sinistre-scenario">
          <h4>Situation :</h4>
          <p>
            Un client glisse sur un sol mouillé dans votre boutique et se fracture le poignet. 
            Incapacité de travail de 3 mois, il est chef d'entreprise indépendant.
          </p>
          <h4>Prise en charge RC Pro :</h4>
          <ul>
            <li><i class="fas fa-check"></i> Frais médicaux et hospitalisation : 6 000 €</li>
            <li><i class="fas fa-check"></i> Indemnisation incapacité temporaire (perte de revenus) : 25 000 €</li>
            <li><i class="fas fa-check"></i> Préjudice moral et souffrance : 8 000 €</li>
            <li><i class="fas fa-check"></i> Frais de justice : 4 000 €</li>
          </ul>
          <div class="sinistre-total">
            <strong>Total pris en charge :</strong> 43 000 €
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Comment Réduire le Coût de votre RC Pro ?</h2>

    <div class="reduction-tips">
      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-balance-scale"></i>
        </div>
        <h3>1. Comparez les Offres</h3>
        <p>
          Les tarifs peuvent varier considérablement d'un assureur à l'autre pour une même couverture. 
          Utilisez un comparateur en ligne et demandez plusieurs devis personnalisés.
        </p>
        <div class="tip-savings">Économie possible : 20% à 40%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-layer-group"></i>
        </div>
        <h3>2. Regroupez vos Contrats</h3>
        <p>
          Souscrire plusieurs assurances chez le même assureur (RC Pro + local + santé + prévoyance) 
          vous permet d'obtenir des réductions importantes.
        </p>
        <div class="tip-savings">Économie possible : 10% à 25%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-sliders-h"></i>
        </div>
        <h3>3. Adaptez les Garanties</h3>
        <p>
          Ne payez pas pour des garanties dont vous n'avez pas besoin. Évaluez précisément vos risques 
          et ajustez les plafonds en fonction de vos contrats réels.
        </p>
        <div class="tip-savings">Économie possible : 15% à 30%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-hand-holding-usd"></i>
        </div>
        <h3>4. Augmentez la Franchise</h3>
        <p>
          Accepter de prendre en charge une partie du sinistre (franchise de 500 € à 2 000 €) réduit 
          significativement votre prime annuelle.
        </p>
        <div class="tip-savings">Économie possible : 10% à 20%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-shield-alt"></i>
        </div>
        <h3>5. Mettez en Place des Mesures de Prévention</h3>
        <p>
          Procédures qualité, certifications (ISO, labels), formations régulières des équipes, et 
          documentation rigoureuse réduisent le risque et la prime.
        </p>
        <div class="tip-savings">Économie possible : 5% à 15%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-file-signature"></i>
        </div>
        <h3>6. Utilisez des Contrats Types et CGV Claires</h3>
        <p>
          Des conditions générales de vente bien rédigées, des devis détaillés, et des contrats 
          validés par un avocat limitent les litiges et les sinistres.
        </p>
        <div class="tip-savings">Économie possible : 5% à 10%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-calendar-alt"></i>
        </div>
        <h3>7. Évitez les Sinistres</h3>
        <p>
          Un bon historique sans sinistre pendant plusieurs années vous permet de négocier des 
          réductions ou un bonus malus favorable lors du renouvellement.
        </p>
        <div class="tip-savings">Économie possible : 10% à 30%</div>
      </div>

      <div class="tip-card">
        <div class="tip-icon">
          <i class="fas fa-sync-alt"></i>
        </div>
        <h3>8. Renégociez Chaque Année</h3>
        <p>
          Ne laissez pas votre contrat se renouveler automatiquement sans vérifier. Chaque année, 
          comparez et renégociez avec votre assureur ou changez si nécessaire.
        </p>
        <div class="tip-savings">Économie possible : 10% à 25%</div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Questions Fréquentes (FAQ)</h2>

    <div class="faq-container">
      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> La RC Pro est-elle obligatoire pour mon activité ?</h3>
        <p>
          Elle est obligatoire pour les professions réglementées (santé, droit, BTP, experts-comptables, 
          agents immobiliers, etc.). Pour les autres activités, elle n'est pas légalement obligatoire 
          mais fortement recommandée. Certains clients ou partenaires peuvent l'exiger contractuellement.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Quelle différence entre RC Exploitation et RC Professionnelle ?</h3>
        <p>
          La <strong>RC Exploitation</strong> couvre les dommages liés à votre activité courante (locaux, 
          matériel, salariés) mais pas les fautes professionnelles. La <strong>RC Professionnelle</strong> 
          couvre spécifiquement les erreurs, négligences, et fautes dans l'exercice de votre métier. 
          Souvent, les deux sont regroupées dans un contrat "RC Pro complète".
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Suis-je couvert pour les dommages causés par mes salariés ?</h3>
        <p>
          Oui, la RC Pro couvre les fautes et erreurs commises par vos salariés dans le cadre de leur 
          travail. Vous êtes responsable civilement des actes de vos préposés (article 1242 du Code civil).
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Les sous-traitants sont-ils couverts par ma RC Pro ?</h3>
        <p>
          Non, chaque entreprise doit avoir sa propre RC Pro. Si vous faites appel à un sous-traitant, 
          assurez-vous qu'il dispose de sa propre assurance et demandez-lui une attestation. Vous pouvez 
          souscrire une extension "RC du fait des sous-traitants" pour plus de sécurité.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Combien de temps après un sinistre puis-je déclarer ?</h3>
        <p>
          Vous devez déclarer le sinistre dès que vous en avez connaissance, généralement dans les 
          <strong>5 jours ouvrés</strong>. En cas de retard de déclaration, l'assureur peut refuser la 
          prise en charge si ce retard lui a causé un préjudice.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> La RC Pro couvre-t-elle les dommages à mes propres biens ?</h3>
        <p>
          Non, la RC Pro couvre uniquement les dommages causés à des tiers. Pour protéger vos propres 
          locaux, matériel, et marchandises, vous devez souscrire une assurance multirisque professionnelle.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Que se passe-t-il si je change d'activité ?</h3>
        <p>
          Vous devez immédiatement informer votre assureur de tout changement d'activité, d'augmentation 
          de CA, ou d'extension de vos prestations. Ces modifications peuvent nécessiter un ajustement 
          de votre contrat et de votre prime.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Puis-je être couvert rétroactivement ?</h3>
        <p>
          La plupart des contrats RC Pro fonctionnent en "fait dommageable" : le sinistre doit survenir 
          pendant la période de couverture. Il existe des extensions de "garantie rétroactivité" qui 
          couvrent les fautes commises avant la souscription mais découvertes pendant le contrat.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> La RC Pro couvre-t-elle les amendes et sanctions pénales ?</h3>
        <p>
          Non, les amendes pénales et les sanctions administratives ne sont jamais couvertes par 
          l'assurance (interdiction légale). Seules les conséquences civiles (dommages-intérêts) 
          sont prises en charge.
        </p>
      </div>

      <div class="faq-item">
        <h3><i class="fas fa-question-circle"></i> Dois-je garder mon assurance RC Pro après avoir cessé mon activité ?</h3>
        <p>
          Oui, il est fortement recommandé de souscrire une <strong>garantie postérieure</strong> 
          (garantie après cessation d'activité). Elle vous protège contre les réclamations liées à 
          des fautes commises pendant votre activité mais découvertes après votre cessation.
        </p>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <h2>Protégez Votre Activité avec la RC Pro</h2>
    <p>
      Ne prenez pas le risque de mettre en péril votre entreprise et votre patrimoine personnel. 
      Comparez les meilleures offres de RC Pro adaptées à votre secteur et obtenez votre devis 
      personnalisé en quelques clics.
    </p>
    <a href="/comparaison" class="cta-button">
      <i class="fas fa-calculator"></i> Comparer les Assurances RC Pro
    </a>
  </div>

</app-page-layout>
